module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-edit"
  }, [_c('b-form', {
    staticClass: "mb-3",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitAndStay($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [(_vm.mode == 'edit') ? _c('h1', {
    staticClass: "display-4"
  }, [_vm._v(_vm._s(_vm.$t('item.edit')))]) : _vm._e(), _vm._v(" "), (_vm.mode == 'add') ? _c('h1', {
    staticClass: "display-4"
  }, [_vm._v(_vm._s(_vm.$t('item.addPageTitle')))]) : _vm._e(), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.form.title))])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('action-buttons', {
    staticClass: "pull-right",
    attrs: {
      "disable-previous": _vm.item.previous_id == null,
      "disable-next": _vm.item.next_id == null,
      "disable-delete": true
    },
    on: {
      "previous-item": _vm.previousItem,
      "next-item": _vm.nextItem,
      "save-and-back": _vm.submitAndBack,
      "save-and-new": _vm.submitAndNew,
      "back": _vm.goBack
    }
  })], 1)]), _vm._v(" "), (_vm.formError.errors) ? _c('b-alert', {
    attrs: {
      "show": "",
      "variant": "warning"
    }
  }, _vm._l((_vm.formError.errors), function(errors) {
    return _c('span', _vm._l((errors), function(error) {
      return _c('span', [_vm._v(_vm._s(error)), _c('br')])
    }), 0)
  }), 0) : _vm._e(), _vm._v(" "), _c('partial-loader', {
    attrs: {
      "loading": _vm.isFetching
    }
  }), _vm._v(" "), (!_vm.isFetching && !_vm.isLoading) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-9"
  }, [_c('seller-field', {
    attrs: {
      "mode": _vm.mode
    },
    on: {
      "update:person": _vm.updateSellerId
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-3"
  }, [_c('b-form-group', {
    attrs: {
      "label": ((_vm.$t('item.itemNumber')) + " *")
    }
  }, [_c('b-input-group', [(_vm.seller.code) ? _c('b-input-group-prepend', {
    attrs: {
      "is-text": ""
    }
  }, [_vm._v(_vm._s(_vm.seller.code))]) : _vm._e(), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "number",
      "disabled": _vm.seller.code == null,
      "step": "1",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.number),
      callback: function($$v) {
        _vm.$set(_vm.form, "number", $$v)
      },
      expression: "form.number"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-9"
  }, [_c('category-field', {
    ref: "categoryField",
    attrs: {
      "mode": _vm.mode
    },
    on: {
      "update:category": _vm.updateCategoryId
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-3"
  }, [_c('b-form-group', {
    attrs: {
      "label": _vm.$t('item.auctionOrderNumber')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "step": "1",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.auction_order_number),
      callback: function($$v) {
        _vm.$set(_vm.form, "auction_order_number", $$v)
      },
      expression: "form.auction_order_number"
    }
  })], 1)], 1)]), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": ((_vm.$t('item.title')) + " *")
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "title",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.$set(_vm.form, "title", $$v)
      },
      expression: "form.title"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": _vm.$t('item.tags')
    }
  }, [_c('multiselect', {
    attrs: {
      "tag-placeholder": "Add this as new tag",
      "placeholder": "Search or add a tag",
      "label": "name",
      "track-by": "name",
      "options": _vm.tags,
      "loading": _vm.isFetchingTags,
      "close-on-select": false,
      "multiple": true,
      "taggable": true
    },
    model: {
      value: (_vm.form.tags),
      callback: function($$v) {
        _vm.$set(_vm.form, "tags", $$v)
      },
      expression: "form.tags"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-4"
  }, [_c('b-form-group', {
    attrs: {
      "label": _vm.$t('item.parts')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "step": "any",
      "min": "0",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.parts),
      callback: function($$v) {
        _vm.$set(_vm.form, "parts", $$v)
      },
      expression: "form.parts"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-4"
  }, [_c('b-form-group', {
    attrs: {
      "label": _vm.$t('item.quality')
    }
  }, [_c('multiselect', {
    attrs: {
      "id": "quality",
      "select-label": _vm.$t('common.select'),
      "placeholder": _vm.$t('item.selectQuality'),
      "selectedLabel": _vm.$t('common.selected'),
      "deselectLabel": _vm.$t('common.deselect'),
      "options": _vm.qualityOptions
    },
    model: {
      value: (_vm.form.quality),
      callback: function($$v) {
        _vm.$set(_vm.form, "quality", $$v)
      },
      expression: "form.quality"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-4"
  }, [_c('b-form-group', {
    attrs: {
      "label": _vm.$t('item.limit')
    }
  }, [_c('b-input-group', [_c('b-input-group-prepend', {
    attrs: {
      "is-text": ""
    }
  }, [_c('i', {
    staticClass: "fas fa-euro-sign fa-fw"
  })]), _vm._v(" "), _c('b-form-input', {
    staticClass: "text-right",
    attrs: {
      "type": "number",
      "step": "1",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.limit),
      callback: function($$v) {
        _vm.$set(_vm.form, "limit", $$v)
      },
      expression: "form.limit"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('b-form-group', {
    attrs: {
      "label": _vm.$t('item.targetprice', {
        number: 1
      })
    }
  }, [_c('b-input-group', [_c('b-input-group-prepend', {
    attrs: {
      "is-text": ""
    }
  }, [_c('i', {
    staticClass: "fas fa-euro-sign fa-fw"
  })]), _vm._v(" "), _c('b-input', {
    staticClass: "text-right",
    attrs: {
      "type": "number",
      "step": "1"
    },
    model: {
      value: (_vm.form.target_price_1),
      callback: function($$v) {
        _vm.$set(_vm.form, "target_price_1", $$v)
      },
      expression: "form.target_price_1"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('b-form-group', {
    attrs: {
      "label": _vm.$t('item.targetprice', {
        number: 2
      })
    }
  }, [_c('b-input-group', [_c('b-input-group-prepend', {
    attrs: {
      "is-text": ""
    }
  }, [_c('i', {
    staticClass: "fas fa-euro-sign fa-fw"
  })]), _vm._v(" "), _c('b-form-input', {
    staticClass: "text-right",
    attrs: {
      "type": "number",
      "step": "1",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.target_price_2),
      callback: function($$v) {
        _vm.$set(_vm.form, "target_price_2", $$v)
      },
      expression: "form.target_price_2"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('b-form-group', {
    attrs: {
      "label": _vm.$t('item.sellerCommisionPercentage')
    }
  }, [_c('b-input-group', [_c('b-input-group-prepend', {
    attrs: {
      "is-text": ""
    }
  }, [_c('i', {
    staticClass: "fas fa-percentage fa-fw"
  })]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "number",
      "step": "any",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.seller_commission_percentage),
      callback: function($$v) {
        _vm.$set(_vm.form, "seller_commission_percentage", $$v)
      },
      expression: "form.seller_commission_percentage"
    }
  })], 1), _vm._v(" "), (_vm.form.seller_commission_percentage > 0 && _vm.form.seller_commission > 0) ? _c('b-form-text', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.$t('item.sellerCommissionPercentageIgnored')) + "\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('b-form-group', {
    attrs: {
      "label": _vm.$t('item.sellerCommission')
    }
  }, [_c('b-input-group', [_c('b-input-group-prepend', {
    attrs: {
      "is-text": ""
    }
  }, [_c('i', {
    staticClass: "fas fa-euro-sign fa-fw"
  })]), _vm._v(" "), _c('b-form-input', {
    staticClass: "text-right",
    attrs: {
      "type": "number",
      "step": "any",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.seller_commission),
      callback: function($$v) {
        _vm.$set(_vm.form, "seller_commission", $$v)
      },
      expression: "form.seller_commission"
    }
  })], 1)], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-4"
  }, [_c('b-form-group', [_c('b-form-checkbox', {
    attrs: {
      "value": "1",
      "unchecked-value": "0"
    },
    model: {
      value: (_vm.form.no_photo_cost),
      callback: function($$v) {
        _vm.$set(_vm.form, "no_photo_cost", $$v)
      },
      expression: "form.no_photo_cost"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.$t('item.noPhotoCost')) + "\n\t\t\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('b-form-group', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode == 'edit'),
      expression: "mode == 'edit'"
    }],
    attrs: {
      "label": ""
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "value": "1",
      "unchecked-value": "0"
    },
    model: {
      value: (_vm.form.paid),
      callback: function($$v) {
        _vm.$set(_vm.form, "paid", $$v)
      },
      expression: "form.paid"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.$t('item.paid')) + "\n\t\t\t\t\t\t\t\t")])], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-xl-6"
  }, [_c('b-form-group', {
    attrs: {
      "label": _vm.$t('item.description')
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": 14
    },
    model: {
      value: (_vm.form.description),
      callback: function($$v) {
        _vm.$set(_vm.form, "description", $$v)
      },
      expression: "form.description"
    }
  })], 1), _vm._v(" "), (!_vm.isFetching && _vm.mode != 'add' && _vm.item['moved_from_item_id'] !== null) ? _c('p', {
    staticClass: "font-italic"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.$t('item.movedFrom')) + " "), _c('router-link', {
    attrs: {
      "to": {
        name: 'itemEdit',
        params: {
          auctionId: _vm.item['moved_from']['auction_id'],
          itemId: _vm.item['moved_from']['item_id']
        }
      }
    }
  }, [_vm._v(" deze veiling. ")])], 1) : _vm._e(), _vm._v(" "), (!_vm.isFetching && _vm.item.bid == null && _vm.pendingBids.meta.total < 1 && _vm.item['moved_to_item_id'] == null) ? _c('autocomplete-auction', {
    attrs: {
      "selected": _vm.item.auction,
      "label": _vm.$t('item.auctionMove'),
      "deletable": false,
      "reset-after": true,
      "hide-selected": true,
      "searchable": false,
      "placeholderLabel": _vm.$t('item.selectAuction'),
      "allow-empty": false
    },
    on: {
      "update:auction": _vm.changeAuctionModal
    }
  }) : (!_vm.isFetching && _vm.mode != 'add' && _vm.item['moved_to_item_id'] !== null) ? _c('p', {
    staticClass: "font-italic"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.$t('item.movedTo')) + " "), _c('router-link', {
    attrs: {
      "to": {
        name: 'itemEdit',
        params: {
          auctionId: _vm.item['moved_to']['auction_id'],
          itemId: _vm.item['moved_to']['item_id']
        }
      }
    }
  }, [_vm._v(" deze veiling. ")])], 1) : _c('p', {
    staticClass: "font-italic"
  }, [_vm._v(_vm._s(_vm.$t('item.cantMove')) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('modal', {
    ref: "changeAuctionModal",
    attrs: {
      "title": _vm.$t('item.auctionMove')
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.$t('item.auctionMoveDialog', {
    auctionName: _vm.modals.auction.title
  })) + "\n\t\t\t\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "type": "button",
      "variant": "outline-primary",
      "block": ""
    },
    on: {
      "click": _vm.cancelAuctionModal
    }
  }, [_vm._v(_vm._s(_vm.$t('common.cancel')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "type": "button",
      "disabled": _vm.modals.auction.loading,
      "block": "",
      "variant": "outline-danger"
    },
    on: {
      "click": function($event) {
        return _vm.updateAuctionId(_vm.modals.auction.selected)
      }
    }
  }, [_c('loader-spinner', {
    attrs: {
      "text": _vm.$t('item.auctionMove'),
      "show-spinner": _vm.modals.auction.loading
    }
  })], 1)], 1)])])])], 1)]), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "Afbeeldingen:"
    }
  }, [(_vm.mode == 'edit') ? _c('media') : _vm._e(), _vm._v(" "), (_vm.mode == 'add') ? _c('b-alert', {
    attrs: {
      "variant": "warning",
      "show": ""
    }
  }, [_vm._v("Sla het kavel op om afbeeldingen toe te voegen.\n\t\t\t\t\t"), _c('b-button', {
    attrs: {
      "type": "submit",
      "size": "sm",
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-save"
  }), _vm._v(" Sla direct op")])], 1) : _vm._e()], 1), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.$t('common.requiredFields')))]), _vm._v(" "), _c('action-buttons', {
    staticClass: "pull-right",
    attrs: {
      "disablePrevious": _vm.item.previous_id == null,
      "disableNext": _vm.item.next_id == null,
      "disable-delete": true
    },
    on: {
      "previous-item": _vm.previousItem,
      "next-item": _vm.nextItem,
      "save-and-back": _vm.submitAndBack,
      "save-and-new": _vm.submitAndNew,
      "back": _vm.goBack
    }
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e248a970"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Auction/Item/Form/ItemForm.vue
// module id = 1343
// module chunks = 1